module.exports = __webpack_public_path__ + "static/media/chat-message-communication-svgrepo-com.4133793d.svg";